import { formatMoney } from '@nemuru-eng/js-api-client';

import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const adjustmentsAmountFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'adjustments_amount',
    sortable: false,
    align: 'right',
    type: 'number',
    headerName: <Text tId={'ADJUSTMENTS_AMOUNT'} />,
    renderCell: (rowData: PayoutsListRowProps) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            whiteSpace: 'break-spaces',
            lineHeight: '1.43',
          }}
        >
          <div className={'line-clamp-3'}>{formatMoney(amountToValueMoneyMapper(rowData.row.adjustmentsAmount))}</div>
        </div>
      </>
    ),
  };
};
